import { React } from 'react';
import ReactECharts from 'echarts-for-react';  // or var ReactECharts = require('echarts-for-react');

// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';

// Import charts, all with Chart suffix
import {
  // LineChart,
  // BarChart,
  // PieChart,
  // ScatterChart,
  // RadarChart,
  // MapChart,
  // TreeChart,
  // TreemapChart,
  // GraphChart,
  GaugeChart,
  // FunnelChart,
  // ParallelChart,
  // SankeyChart,
  // BoxplotChart,
  // CandlestickChart,
  // EffectScatterChart,
  // LinesChart,
  // HeatmapChart,
  // PictorialBarChart,
  // ThemeRiverChart,
  // SunburstChart,
  // CustomChart,
} from 'echarts/charts';
// import components, all suffixed with Component
import {
  // GridSimpleComponent,
  GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  // LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  // DataZoomComponent,
  // DataZoomInsideComponent,
  // DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from 'echarts/components';
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
  CanvasRenderer,
  // SVGRenderer,
} from 'echarts/renderers';
const colorsArray2 = [
  { name: 'charging', color: '#6A9930' },
  { name: 'connected', color: '#E5972D' },
  { name: 'discharging', color: '#5696AD' },
  // { name: 'unplugged', color: '#B472B5' },
  { name: 'plugged', color: '#E5972D' },
  { name: 'available', color: '#B472B5' },
  { name: 'alert', color: '#A23B3E' },
  { name: 'offline', color: '#353535' },
  { name: 'down', color: '#A23B3E' },
  { name: 'up', color: '#6A9930' },
]


const Donut = (props) => {
  // Register the required components
  echarts.registerTheme('my_theme', {
    backgroundColor: '#f4cccc'
  });
  // var colorsArray = [];
  var colorsArray = props.data.map(function (obj) {
    
    return obj.color;
    // colorsArray2.find((val) => {
    //   if (val?.name === obj?.colorName) {
    //     colorsArray.push(val?.color === undefined ? '' : val.color)
    //   }
    // })
  });


  echarts.use(
    [TitleComponent, TooltipComponent, GridComponent, GaugeChart, CanvasRenderer]
  );
  var totalSum = 0
  for (let i = 0; i < props?.data.length; i++) {
    let total = props?.data[i].value !== "" ? props?.data[i].value : 0
    totalSum += parseInt(total);

  }



  const options = () => (
    {
      // tooltip: {
      //   trigger: 'item'
      // },
      grid: {
        left: 20,

      },


      tooltip: {
        //for 13june
        show: false,
        trigger: "item",
        formatter: (params) => {
          let Nameval = params.data.name;
          var splitStr = Nameval.toLowerCase().split(' ');
          for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            return splitStr.join(' ');
          }
        },
        triggerOn: "none",
      },
      legend: {
        //for 13june
        selectedMode: false,
        orient: 'vertical',
        top: 'center',
        icon: "circle",
        bottom: 0,
        left: window.screen.width <= 1399 ? 85 :window.screen.width <=1400? 100:110,
        type: window.screen.width < 1160 && window.screen.width > 991 ? 'scroll' : 'plain',
        // itemGap:40,
        textStyle: {
          color: "#000000",
          fontFamily: "Montserrat",
          fontWeight: "normal",
          fontSize: window.screen.width < 1399 ? 12 : 14,
        },
        formatter: (params) => {
          var splitStr = params.toLowerCase().split(' ');
          for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
          }
          return splitStr.join(' ');
        }
      },
      series: [
        {
          //removed verbiage "access from" CR june 28
          name: '',
          right: '30%',
          //for 13june
          legendHoverLink: false,
          emphasis: {
            disabled: true,
            scale: false
          },
          type: 'pie',
          radius: window.screen.width <= 1440 ? ['45%', '75%'] : window.screen.width >= 1680 ? ['55%', '85%'] : ['55%', '85%'],
          center: window.screen.width <= 1440 ? ['17%', '50%'] : window.screen.width >= 1680 ? ['18%', '50%'] : ['17%', '50%'],
          avoidLabelOverlap: true,
          silent: true,
          label: {
            show: true,
            position: 'center',
            formatter: '{x|' + totalSum + '}{a| }',
            fontFamily: "Montserrat",
            fontWeight: "normal",
            fontStyle: "bold",
            fontSize: 12,
            rich: {
              a: {
                color: 'red',
                lineHeight: 10,
                fontSize: 12,
              },
              x: {
                fontSize: '1em',
                fontFamily: 'Montserrat',
                borderColor: '#449933',
                // borderRadius: 4,
                fontweight: 'bold',
                fontStyle: "bold",
              }
            }
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '12',
              fontWeight: 'normal',
            }
          },
          labelLine: {
            show: false
          },
          color: colorsArray,
          data: props.data
        }
      ]
    });


  return (
    <ReactECharts
      echarts={echarts}
      //option={this.getOption()}
      // notMerge={true}
      // lazyUpdate={true}
      theme={"theme_name"}
      //onChartReady={this.onChartReadyCallback}
      //onEvents={EventsDict}
      style={{
        height: '94px',
        width: '100%',

        maxWidth: '95%',
        marginTop: '20px'
      }}
      // opts={{renderer: 'svg'}} // use svg to render the chart.
      option={options()}
    />
  )

};

export default Donut;


